import CurrentSubscriptionPlanName
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionPlanName.vue";
import CurrentSubscriptionPrice
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionPrice.vue";
import CurrentSubscriptionBillingFrequency
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionBillingFrequency.vue";
import CurrentSubscriptionStatus
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionStatus.vue";
import CurrentSubscriptionNextBillingDate
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionNextBillingDate.vue";
import CurrentSubscriptionLastPaymentDate
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionLastPaymentDate.vue";
import CurrentSubscriptionNote
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionNote.vue";
import CurrentSubscriptionReturnRedirect
  from "%/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionReturnRedirect.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacySubscription extends LegacyEntity {
  get elements() {
    return {
      CurrentSubscriptionPlanName,
      CurrentSubscriptionPrice,
      CurrentSubscriptionBillingFrequency,
      CurrentSubscriptionStatus,
      CurrentSubscriptionNextBillingDate,
      CurrentSubscriptionLastPaymentDate,
      CurrentSubscriptionNote,
      CurrentSubscriptionReturnRedirect,
    };
  }
}
